import { collectionEngineV1 } from '../../apis';
const apcoaAPI = collectionEngineV1('/apcoa');
export const getFeeImages = (feeId) => apcoaAPI('GET', `/fee/${feeId}/images`);
export const getFee = (feeId) => apcoaAPI('GET', `/fee/${feeId}`);
export const getDMR = (feeId, registrationNumber) => apcoaAPI('GET', `/dmr/${feeId}?registrationNumber=${registrationNumber}`);
export const getParkingLot = (parkingLotCode) => apcoaAPI('GET', `/parkinglot/${parkingLotCode}`);
export const getParkingLotFiles = (parkingLotCode) => apcoaAPI('GET', `/parkinglot/${parkingLotCode}/files`);
export const getParkingLotFile = (parkingLotCode, path) => apcoaAPI('GET', `/parkinglot/${parkingLotCode}/files/${path}`);
export const patchParkingLot = (parkingLotCode, patch) => apcoaAPI('PATCH', `/parkinglot/${parkingLotCode}`, {
    body: patch,
});
export const getNavZip = (caseSeqId) => apcoaAPI('GET', `/nav-zip/${caseSeqId}`);
//# sourceMappingURL=apcoa.js.map